import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LockIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Button } from '../components/ui/Button';
import { Card, SectionTitle } from '../components/ui/Card';
import { Switch } from '../components/ui/Switch';
import { useLocale } from '../contexts/LocaleContext';
import { useMetrics } from '../contexts/MetricsContext';
import type { BodyMetricId } from '../types';
import { convert, formatMetric, unitLabel } from '../utils/units';
export function EditBodyMetrics() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const metrics = useMetrics();
  const editable = metrics.bodyMetrics.filter(metric => metric.editable);
  return <div className="px-2 pb-2" data-id="element-2691" data-mp="2ca6t7yuryq33">
      <PageHeader title={t('metrics.editBody')} subtitle={t('metrics.editHint')} showBack data-id="element-2692" data-mp="vxhyms50wg92" />

      <Card className="p-2" data-id="element-2693" data-mp="10x4df60i24jz">
        <SectionTitle data-id="element-2694" data-mp="10xcocsd2azsj">{t('metrics.values')}</SectionTitle>
        <ul data-id="element-2695" data-mp="2apb1wwbrzkcm">
          {editable.map(metric => <li key={metric.id} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-2696" data-mp="2aq2wq4xjte1u">
              <label className="min-w-0 flex-1" data-id="element-2697" data-mp="2koa5i0hoopsr">
                <span className="block text-[13px] font-medium text-deep" data-id="element-2698" data-mp="2kp1wey0c5zcp">
                  {t(`metrics.${metric.id}`)}
                </span>
                <span className="mt-1 flex items-center gap-1" data-id="element-2699" data-mp="2tnx3sdf49fhl">
                  <input type="number" inputMode="decimal" step="0.1" value={metric.value > 0 ? Number(convert(metric.kind, metric.value, metrics.unitSystem).toFixed(1)) : ''} placeholder={t('metrics.notSet')} onChange={event => {
                const shown = Number(event.target.value);
                if (Number.isNaN(shown)) return;
                const back = metrics.unitSystem === 'metric' ? shown : shown / (convert(metric.kind, 1, metrics.unitSystem) || 1);
                metrics.updateBodyMetric(metric.id as BodyMetricId, back);
              }} className="h-11 w-[110px] rounded-card border border-sand-line bg-white/80 px-2 text-[14px] font-bold text-deep focus:border-deep/40" data-id="element-2700" data-mp="2tm2iuz3uhndi" />
                  <span className="text-[11.5px] font-medium text-muted" data-id="element-2701" data-mp="bz9licld8hl6">
                    {unitLabel(metric.kind, metrics.unitSystem)}
                  </span>
                </span>
              </label>
              <span className="flex shrink-0 flex-col items-end gap-1" data-id="element-2702" data-mp="2drxrgtpe9j4n">
                <span className="bee-overline text-[8.5px] font-bold text-muted" data-id="element-2703" data-mp="2iq8wmr4qv5gj">
                  {t('metrics.visible')}
                </span>
                <Switch checked={!metrics.isHidden(metric.id)} onChange={() => metrics.toggleHidden(metric.id)} label={`${t('metrics.visible')} — ${t(`metrics.${metric.id}`)}`} data-id="element-2704" data-mp="zvxqqcnsundn" />
              </span>
            </li>)}
        </ul>
      </Card>

      <Card className="mt-2 p-2" data-id="element-2705" data-mp="m5kh85v9f0m7">
        <SectionTitle data-id="element-2706" data-mp="1itqhkgl5f6uo">{t('metrics.bmi')}</SectionTitle>
        <div className="flex items-center gap-2" data-id="element-2707" data-mp="1it7ci0glkcy2">
          <span className="bee-num text-[26px] font-bold leading-none text-deep" data-id="element-2708" data-mp="1ervk5n6c9dm6">
            {metrics.bmi > 0 ? formatMetric('bmi', metrics.bmi, metrics.unitSystem) : '—'}
          </span>
          <span className="flex items-center gap-1 text-[11.5px] text-muted" data-id="element-2709" data-mp="14t5zxnqyzh2r">
            <LockIcon size={12} aria-hidden="true" data-id="element-2710" data-mp="3uk2kzve63u00" />
            {t('metrics.bmiHint')}
          </span>
        </div>
      </Card>

      <Button variant="gold" size="lg" fullWidth className="mt-3" onClick={() => navigate('/perfil/corpo')} data-id="element-2711" data-mp="3pjoonalxi8ht">
        {t('common.save')}
      </Button>
    </div>;
}